// extracted by mini-css-extract-plugin
export var container = "_i1-0";
export var content = "_i1-3";
export var customerTitle = "_i1-4";
export var empty = "_i1-5";
export var gray = "_i1-6";
export var header = "_i1-7";
export var info = "_i1-8";
export var loading = "_i1-2";
export var loadingCard = "_i1-9";
export var oneLine = "_i1-a";
export var personName = "_i1-e";
export var pillContainer = "_i1-b";
export var selected = "_i1-1";
export var text = "_i1-c";
export var twoLines = "_i1-d";
export var unread = "_i1-f";
export var unreadIndicator = "_i1-g";